<template>
  <v-container fill-height fluid pa-0>
    <v-layout align-center>
      <v-flex>
        <circle-spinner />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { VContainer, VLayout, VFlex } from 'vuetify/lib';
import { bizgainOnboardingRoutes } from 'Features/bizgainOnboarding/constants';
import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
const { getSummaryId } = new ApiService();
export default {
  components: {
    VContainer,
    VLayout,
    VFlex
  },
  data(){
    return {
      bizgainOnboardingRoutes,
      summaryLink: 'link',
      show: false,
      agentId: null
    }
  },
  async created() {
    if(this.$route.params.encodedId){
      let { sessionId } = await getSummaryId(this.$route.params.encodedId);
      let query = {
        sessionId: sessionId
      }
      this.$router.push({ name: this.bizgainOnboardingRoutes.Summary.name, query: query });
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
</style>